<template>
  <div class="incidents-widget">
    <h2><span class="fa fa-bell" /> Incidents</h2>
    <div v-if="config.endpoint">
      <div v-if="loading">
        Loading Incidents <span class="fa fa-sync anim-spin" />
      </div>
      <div v-else class="table-responsive">
        <table class="table table-sm table-striped table-hover table-bordered text-center">
          <thead>
            <tr>
              <th class="text-left">
                Type
              </th>
              <th class="text-center" colspan="3">
                Today
              </th>
              <th class="text-center" colspan="2">
                Last 7 Days
              </th>
              <th class="text-center" colspan="2">
                Last 30 Days
              </th>
            </tr>
            <tr>
              <th />
              <th>New</th>
              <th>Open</th>
              <th>All</th>
              <th>Unresolved</th>
              <th>Average</th>
              <th>Unresolved</th>
              <th>Average</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="incident in incidents">
              <td class="text-left">
                <a :href="incident.linkToAdmin">{{ incident.type }}</a>
              </td>
              <td>{{ incident.today.new }}</td>
              <td>{{ incident.today.open }}</td>
              <td>{{ incident.today.all }}</td>
              <td>{{ incident.last7.unresolved }}</td>
              <td>{{ incident.last7.average }}</td>
              <td>{{ incident.last30.unresolved }}</td>
              <td>{{ incident.last30.average }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else class="center">
      <p>Incidents will display after a page refresh</p>
    </div>
  </div>
</template>
<script>
  import axios from "axios";

  export default {
    props: {
      config: {
        type: Object,
        default: () => {
          return { endpoint: null }
        }
      }
    },
    data() {
      return {
        loading: true,
        incidents: []
      }
    },
    mounted() {
      if (this.config.endpoint) {
        axios
          .get(
            this.config.endpoint,
            {
              headers: {'X-Requested-With': 'XMLHttpRequest'},
            }
          )
          .then(res => {
            this.loading = false;
            this.incidents = res.data;
          });
      }
    }
  };
</script>

<style scoped>
  .center p {
    font-weight: bold;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
